/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable sonarjs/no-identical-functions */
/* eslint-disable sonarjs/no-duplicate-string */
import { isEmpty, isNull, uniqWith, isArray } from 'lodash';
import moment from 'moment';
import * as Yup from 'yup';

/**
 * Add custom method to Yup array to validate unique cheque and bank name
 */
// https://stackoverflow.com/a/59423867/3882241
Yup.addMethod(Yup.array, 'unique', function testUnique(message) {
	return this.test('unique', message, function uniques(list) {
		// https://stackoverflow.com/a/52525557/3882241
		const uniqueCheques = uniqWith(
			list,
			(chequeA, chequeAB) =>
				chequeA.bank_id === chequeAB.bank_id &&
				chequeA.reference_number === chequeAB.reference_number &&
				chequeA.bank_id &&
				chequeA.reference_number
		);

		return list.length === uniqueCheques.length;
	});
});

export function getIndividualAmount(typeData = []) {
	if (isArray(typeData)) {
		return typeData?.reduce(
			(accumulator, currentValue) => accumulator + Number(currentValue?.amount || 0),
			0
		);
	}

	return 0;
	// if (Number(typeData?.[0]?.amount) > 0) {}
	// return 0;
}

export const initialValues = {
	previousStatus: undefined,
	status: undefined,
	remarks: undefined,
	upiData: [
		// {
		// 	id: Math.random(),
		// 	amount: undefined,
		// 	reference_number: undefined,
		// 	bank_statement_id: undefined,
		// },
	],
	chequeData: [
		{
			id: Math.random(),
			amount: undefined,
			reference_number: undefined,
			bank_id: undefined,
			due_date: undefined,
		},
	],
	neftData: [{ id: Math.random(), amount: undefined, reference_number: undefined }],
};

/**
 * For Amortization Feature
 */
export const initialValuesAmortization = {
	previousStatus: undefined,
	fillType: undefined,
	reason: undefined,
	remarks: undefined,
	upiData: [
		{
			id: Math.random(),
			amount: undefined,
			reference_number: undefined,
			bank_statement_id: undefined,
		},
	],
	chequeData: [
		{
			id: Math.random(),
			amount: undefined,
			reference_number: undefined,
			bank_id: undefined,
			due_date: undefined,
		},
	],
	neftData: [{ id: Math.random(), amount: undefined, reference_number: undefined }],
};

export function getTotalAmount(values) {
	const upi = getIndividualAmount(values?.upiData);
	const cheque = getIndividualAmount(values?.chequeData);
	const neft = getIndividualAmount(values?.neftData);

	return Number(values?.cash || 0) + upi + cheque + neft;
}

export function getSplitedTotal(values) {
	return values?.splitInvoices?.reduce((acc, item) => acc + Number(item?.amount || 0), 0);
}

export function getBalanceAmount(values) {
	const collected = getTotalAmount(values);
	const splitedTotal = getSplitedTotal(values);

	return Number(collected || 0) - Number(splitedTotal || 0);
}

const dateformat = 'YYYY-MM-DD hh:mm:ss';

export function dateFormat(date = '', d_format = dateformat) {
	return moment(date).format(d_format);
}

const delDateFormate = (delivery_date) => {
	console.log(delivery_date);
	const formatedDAte = moment(delivery_date).format('YYYY-MM-DD');
	const timeconst = '11:10:10';

	console.log(formatedDAte);
	const returnAbleDate = `${formatedDAte} ${timeconst}`;

	console.log(returnAbleDate);

	return returnAbleDate;
};

const todatDateFun = () => {
	console.log(moment());
	const formatedDAte = moment().format('YYYY-MM-DD');
	const timeconst = '12:10:10';

	return `${formatedDAte} ${timeconst}`;
};

export function disableDateRanges(values, deliveryDate) {
	console.log(values);
	// https://stackoverflow.com/a/68923354/3882241
	let FUTURE_RANGE = 1;
	const PAST_RANGE = 45;
	/**
	 * By default past dates are 45 from today date
	 */

	const maxAgeBill = values?.splitInvoices?.reduce((prev, current) =>
		prev.invoice_age > current.invoice_age ? prev : current
	);

	console.log(maxAgeBill);

	const dateLimitVal = deliveryDate?.cheque_credit_period;
	const DelDate = moment(delDateFormate(deliveryDate?.delivery_date));
	const todatDate = moment(todatDateFun());

	if (todatDate.diff(DelDate, 'days') < dateLimitVal) {
		FUTURE_RANGE = dateLimitVal - todatDate.diff(DelDate, 'days') || 0;
	} else {
		FUTURE_RANGE = 0;
	}

	const startDate = moment().subtract(PAST_RANGE, 'days');
	const endDate = moment().add(FUTURE_RANGE, 'days');

	return function disabledDate(current) {
		const startCheck = current && current < moment(startDate, dateformat).startOf('day');
		const endCheck = current && current > moment(endDate, dateformat).endOf('day');

		return startCheck || endCheck;
	};
}

export function checkNoBillBack(values, type) {
	const { cash = 0, status, remarks = '', current_outstanding_amount } = values;
	const upiData = getIndividualAmount(values?.upiData);
	const chequeData = getIndividualAmount(values?.chequeData);
	const neftData = getIndividualAmount(values?.neftData);
	const total = cash + chequeData + upiData + neftData;
	const totalPaid = parseFloat(Number(current_outstanding_amount)).toFixed(2);

	if (status === 'No Bill Back' && total < totalPaid) {
		if (type === 'remarks' && (remarks === '' || isNull(remarks))) {
			return false;
		}

		return true;
	}
	if (
		status === 'No Bill Back' &&
		total > totalPaid &&
		type === 'remarks' &&
		(remarks === '' || isNull(remarks))
	) {
		return false;
	}

	return true;
}

export function checkReasonValidation(values, type, all) {
	const { id, reason = '' } = values;
	const { splitInvoices = [] } = all;
	const selectedInvoice = splitInvoices.find((item) => item?.id === id);
	const { status, current_outstanding_amount, amount } = selectedInvoice;
	const totalPaid = Number(parseFloat(Number(current_outstanding_amount)).toFixed(2));

	if (status === 'No Bill Back' && (!amount || amount < totalPaid)) {
		if (type === 'reason' && (reason === '' || isNull(reason))) {
			return false;
		}

		return true;
	}

	return true;
}

export function checkNoBillBackAmortization(values, type, all) {
	const { id, remarks = '' } = values;
	const { splitInvoices = [] } = all;

	const selectedInvoice = splitInvoices.find((item) => item?.id === id);
	const { status, current_outstanding_amount, amount } = selectedInvoice;
	const totalPaid = Number(parseFloat(Number(current_outstanding_amount)).toFixed(2));

	if (
		status === 'No Bill Back' &&
		amount > totalPaid &&
		type === 'remarks' &&
		(remarks === '' || isNull(remarks))
	) {
		return false;
	}

	return true;
}

export function checkValidStatus(values) {
	return new Promise(function abd(resolve, rejected) {
		const { cash = 0, status, current_outstanding_amount } = values;
		const upiData = getIndividualAmount(values?.upiData);
		const chequeData = getIndividualAmount(values?.chequeData);
		const neftData = getIndividualAmount(values?.neftData);
		const total = cash + chequeData + upiData + neftData;
		const totalPaid = parseFloat(Number(current_outstanding_amount)).toFixed(2);
		const extraAmount = current_outstanding_amount + 600;

		if (total > extraAmount) {
			rejected(new Error('More than ₹600 not allowed'));
		}
		if (status === 'Bill Back' && total >= totalPaid) {
			rejected(new Error('Choose No Bill Back'));
		}
		resolve(true);
	});
}

/**
 * For Amortization Feature
 */
export function checkValidStatusAmortization(values) {
	return new Promise(function abd(resolve, rejected) {
		const { amount = 0, status, current_outstanding_amount } = values;
		const totalPaid = parseFloat(Number(current_outstanding_amount)).toFixed(2);
		const extraAmount = current_outstanding_amount + 600;

		if (amount > extraAmount) {
			rejected(new Error('More than ₹600 not allowed'));
		}
		if (status === 'Bill Back' && amount >= totalPaid) {
			rejected(new Error('Choose No Bill Back'));
		}
		resolve(true);
	});
}

/**
 * For Amortization Feature
 */
export function checkValidTotalAmortization(values, all) {
	return new Promise(function abd(resolve, rejected) {
		const { amount = 0 } = values;
		const upiData = getIndividualAmount(all?.upiData);
		const chequeData = getIndividualAmount(all?.chequeData);
		const neftData = getIndividualAmount(all?.neftData);
		const total = Number(all?.cash || 0) + chequeData + upiData + neftData;
		const splitedTotal = getSplitedTotal(all);
		const currentMinusFromTotal = splitedTotal - amount;
		const remainingAmount = total - currentMinusFromTotal;

		if (amount > total) {
			rejected(new Error(`More than ₹${total} not allowed`));
		}

		if (amount > 0 && amount > remainingAmount) {
			rejected(new Error(`Splited total is more than ₹${total}`));
		}

		resolve(true);
	});
}

export function getAmount(data) {
	if (!isArray(data)) {
		return Number(data) > 0;
	}

	return false;
}

// https://stackoverflow.com/a/24921372/3882241
export const FormSchema = Yup.object({
	status: Yup.string()
		.required('*Status Required')
		.label('Status')
		.test('status_check', 'Choose No Bill Back', function validate() {
			return checkValidStatus(this.parent)
				.then(() => true)
				.catch((e) => this.createError(e));
		}),
	cash: Yup.number().label('Cash').positive().min(0).max(199999),
	remarks: Yup.string()
		.trim()
		.nullable()
		.min(10)
		.max(50)
		.label('Remarks')
		.test('remarks_test', 'Remarks required', function validate() {
			return checkNoBillBack(this.parent, 'remarks');
		}),
	upiData: Yup.array().of(
		Yup.object().shape({
			amount: Yup.number().label('UPI'),
			reference_number: Yup.string().when('amount', {
				is: (amount) => amount > 0,
				then: Yup.string()
					.label('*UPI Ref no')
					.min(6, '*UPI Ref no last 6 digits: is required')
					.max(18, '*UPI Ref no not be greater than 18')
					.matches(/^[a-z0-9]+$/i, 'Special characters not allowed')
					.required('*UPI Ref no last 6 digits: is required'),
				otherwise: Yup.string(),
			}),
			bank_statement_id: Yup.string().nullable(),
		})
	),
	chequeData: Yup.array()
		.of(
			Yup.object().shape({
				amount: Yup.number().label('Cheque'),
				reference_number: Yup.string().when('amount', {
					is: (amount) => amount > 0,
					then: Yup.string()
						.label('*Cheque Ref no')
						.matches(
							/^(?=\d{6}$)\d*[1-9]\d*/,
							'Please enter valid last 6 digits of Cheque Ref no'
						)
						.required('*Cheque Ref no last 6 digits: is required'),
					otherwise: Yup.string(),
				}),
				bank_id: Yup.number().when('amount', {
					is: (cheque) => cheque > 0,
					then: Yup.number().label('*Bank Name').required('*Bank Name is required'),
					otherwise: Yup.number(),
				}),
				due_date: Yup.string().when('amount', {
					is: (cheque) => cheque > 0,
					then: Yup.string('*Due Date')
						.label('*Due Date')
						.required('*Due Date is required')
						.nullable(),
					otherwise: Yup.string('Due Date').nullable(),
				}),
			})
		)
		.unique('Cheque reference number and bank name must not be same, please change that'),
	neftData: Yup.array().of(
		Yup.object().shape({
			amount: Yup.number().label('NEFT'),
			reference_number: Yup.string().when('amount', {
				is: (amount) => amount > 0,
				then: Yup.string()
					.label('*NEFT Ref no')
					.matches(
						/^(?=\d{6}$)\d*[1-9]\d*/,
						'Please enter valid last 6 digits of NEFT Ref no'
					)
					.required('*NEFT Ref no last 6 digits: is required'),
				otherwise: Yup.string(),
			}),
		})
	),
});

/**
 * For Amortization Feature
 */

export function getAmortizationValidation(initData, isEditMode, invalidData) {
	const twoLakh = 199999;
	let maxCashAllowed = initData?.cashMaxLimit;

	if (isEditMode) {
		maxCashAllowed = initData?.cashMaxLimit || 0 + initData.cash || 0;
	}

	if (maxCashAllowed > twoLakh) {
		maxCashAllowed = twoLakh;
	}

	console.log('invalid data given', invalidData);

	return Yup.object({
		fillType: Yup.string().required('*Type Required').label('Type'),
		cash: Yup.number().label('Cash').positive().min(0).max(maxCashAllowed),
		upiData: Yup.array().of(
			Yup.object().shape({
				amount: Yup.number().label('UPI'),
				reference_number: Yup.string().when('amount', {
					is: (amount) => amount > 0,
					then: Yup.string()
						.label('*UPI Ref no')
						.min(8, '*UPI Ref no last 8 digits: is required')
						.max(20, '*UPI Ref no not be greater than 20')
						.matches(/^[a-z0-9]+$/i, 'Special characters not allowed')
						.required('*UPI Ref no last 8 digits: is required')
						// eslint-disable-next-line
						.test(function (val) {
							if (invalidData.upis.find((v) => v === val)) {
								return this.createError({
									message: invalidData.message,
								});
							}

							return true;
						}),
					otherwise: Yup.string(),
				}),
				bank_statement_id: Yup.string().nullable(),
			})
		),
		chequeData: Yup.array()
			.of(
				Yup.object().shape({
					amount: Yup.number().label('Cheque'),
					reference_number: Yup.string().when('amount', {
						is: (amount) => amount > 0,
						then: Yup.string()
							.label('*Cheque Ref no')
							.matches(
								/^(?=\d{6}$)\d*[1-9]\d*/,
								'Please enter valid last 6 digits of Cheque Ref no'
							)
							.required('*Cheque Ref no last 6 digits: is required'),
						otherwise: Yup.string(),
					}),
					bank_id: Yup.number().when('amount', {
						is: (cheque) => cheque > 0,
						then: Yup.number().label('*Bank Name').required('*Bank Name is required'),
						otherwise: Yup.number(),
					}),
					due_date: Yup.string().when('amount', {
						is: (cheque) => cheque > 0,
						then: Yup.string('*Due Date')
							.label('*Due Date')
							.required('*Due Date is required')
							.nullable(),
						otherwise: Yup.string('Due Date').nullable(),
					}),
				})
			)
			.unique('Cheque reference number and bank name must not be same, please change that'),
		neftData: Yup.array().of(
			Yup.object().shape({
				amount: Yup.number().label('NEFT'),
				reference_number: Yup.string().when('amount', {
					is: (amount) => amount > 0,
					then: Yup.string()
						.label('*NEFT Ref no')
						.matches(/^(?!0+$)[a-zA-Z0-9]{6,22}$/, 'Please enter a valid NEFT Ref no')
						.min(6)
						.max(22)
						.required('*NEFT Ref no is required')
						// eslint-disable-next-line
						.test(function (val) {
							console.log(invalidData);
							if (invalidData.neft.find((v) => v === val)) {
								return this.createError({
									message: invalidData.message,
								});
							}

							return true;
						}),
					otherwise: Yup.string(),
				}),
			})
		),
		splitInvoices: Yup.array().of(
			Yup.object().shape({
				// amount: Yup.number().label('Amount').min(0).max(199999),
				amount: Yup.number()
					.label('Amount')
					.min(0)
					// .max(199999)
					.test('status_check', 'Max Amount', function validate() {
						return checkValidTotalAmortization(this.parent, this?.from?.[1]?.value)
							.then(() => true)
							.catch((e) => this.createError(e));
					}),
				status: Yup.string()
					.required('*Status Required')
					.label('Status')
					.test('status_check', 'Choose No Bill Back', function validate() {
						return checkValidStatusAmortization(this.parent)
							.then(() => true)
							.catch((e) => this.createError(e));
					}),
				reason: Yup.string()
					.trim()
					.nullable()
					.label('Reason')
					.test('remarks_test', 'Reason required', function validate() {
						return checkReasonValidation(this.parent, 'reason', this?.from?.[1]?.value);
					}),
				remarks: Yup.string()
					.trim()
					.nullable()
					.min(10)
					.max(50)
					.label('Remarks')
					.test('remarks_test', 'Remarks required', function validate() {
						return checkNoBillBackAmortization(
							this.parent,
							'remarks',
							this?.from?.[1]?.value
						);
					}),
			})
		),
	});
}

export function addRemovePayment(arrayHelpers, index, type) {
	let newData = {
		id: Math.random(),
		amount: undefined,
		reference_number: undefined,
	};

	if (type === 'cheque') {
		newData = {
			...newData,
			bank_id: undefined,
			due_date: undefined,
		};
	}
	if (index === 0) {
		arrayHelpers.insert(index + 1, newData);
	} else {
		arrayHelpers.remove(index);
	}
}

export function isAnyDuplicateReference(payment) {
	const isDuplicateNEFTValues = new Set(
		payment?.filter((d) => d?.payment_type === 'NEFT').map((v) => v.reference_number)
	);
	const isDuplicateUPIValues = new Set(
		payment?.filter((d) => d?.payment_type === 'UPI').map((v) => v.reference_number)
	);

	if (
		(isDuplicateNEFTValues.size > 0 &&
			isDuplicateNEFTValues.size <
				payment?.filter((d) => d?.payment_type === 'NEFT').length) ||
		(isDuplicateUPIValues.size > 0 &&
			isDuplicateUPIValues.size < payment?.filter((d) => d?.payment_type === 'UPI').length)
	) {
		return true;
	}

	return false;
}

function getRef(values = []) {
	return values
		?.filter((item) => !isEmpty(item?.reference_number))
		?.map((item) => item?.reference_number);
}

function hasDuplicates(values = []) {
	const noDups = new Set(values);

	return values?.length !== noDups.size;
}

export function UPIAndNEFTRefCheck(values = {}) {
	const neft = getRef(values?.neftData);
	const dupNeft = hasDuplicates(neft);

	const upi = getRef(values?.upiData);
	const dupUpi = hasDuplicates(upi);

	return dupUpi || dupNeft;
}

export function NEFTRefCheck(neftData = []) {
	if (neftData?.length < 2) {
		return false;
	}
	const neft = getRef(neftData);

	return hasDuplicates(neft);
}

export function UPIRefCheck(upiData = []) {
	if (upiData?.length < 2) {
		return false;
	}
	const upi = getRef(upiData);

	return hasDuplicates(upi);
}

export function getSplitPayment(collected, split, values) {
	console.log('getSplitPayment collected', collected);
	console.log('getSplitPayment split', split);
	console.log('getSplitPayment valuess', values?.fillType);

	const payment = [];

	const cash_limit_allowed = Number(split?.oldData?.cash_limit_allowed);

	console.log('all', split?.amount, cash_limit_allowed, values?.fillType);

	if (
		collected?.cash > 0 &&
		cash_limit_allowed > 0 &&
		split?.amount > 0 &&
		collected?.cash >= cash_limit_allowed &&
		split?.amount >= cash_limit_allowed
	) {
		payment.push({
			payment_type: 'Cash',
			amount: cash_limit_allowed,
		});
		collected.cash -= cash_limit_allowed;
		split.amount -= cash_limit_allowed;
		console.log('yes zerroro 1', split?.id);
	} else if (
		collected?.cash > 0 &&
		cash_limit_allowed > 0 &&
		split?.amount > 0 &&
		collected?.cash <= cash_limit_allowed &&
		split?.amount >= collected?.cash
	) {
		payment.push({
			payment_type: 'Cash',
			amount: collected?.cash,
		});
		const cashToMinus = collected.cash;

		collected.cash -= cashToMinus;
		split.amount -= cashToMinus;

		console.log('collected.cash 0xs', collected.cash);
		console.log('split.amount 0x', split.amount);
		console.log('split.amount cq2q 0x', split);

		console.log('yes zerroro 2', split?.id);
	} else if (
		collected?.cash > 0 &&
		cash_limit_allowed > 0 &&
		split?.amount > 0 &&
		collected?.cash <= cash_limit_allowed &&
		split?.amount <= collected?.cash
	) {
		payment.push({
			payment_type: 'Cash',
			amount: split.amount,
		});
		console.log('split.amount zerroro 1', split.amount);
		collected.cash -= split.amount;
		split.amount -= split.amount;
		console.log('split.amount zerroro 2', split.amount);
		console.log('collected.cash zerroro 3', collected.cash);
		console.log('yes zerroro 3', split?.id);
	} else if (split?.amount <= collected?.cash && split?.amount > 0 && cash_limit_allowed > 0) {
		payment.push({
			payment_type: 'Cash',
			amount: split.amount,
		});
		collected.cash -= split.amount;
		split.amount = 0;
		console.log('yes outer 4', split?.id);
	} else if (split?.amount > collected?.cash && collected?.cash > 0 && cash_limit_allowed > 0) {
		payment.push({
			payment_type: 'Cash',
			amount: collected.cash,
		});
		console.log('yes inside', split?.id);
		split.amount -= collected.cash;
		collected.cash = 0;
	} else {
		console.log('caught in no logic');
	}

	console.log('split.amount ~~~ 5x', split.amount);

	collected?.upiData?.forEach((upi) => {
		if (upi?.reference_number && upi?.amount) {
			if (split?.amount <= upi?.amount && split?.amount > 0) {
				console.log('split.amount 1x', split.amount);
				console.log('upi.amount 1x', upi.amount);

				payment.push({
					payment_type: 'UPI',
					reference_number: upi.reference_number.toString(),
					amount: split.amount,
					bank_statement_id: upi.bank_statement_id,
				});
				upi.amount -= split.amount;
				split.amount = 0;
				console.log('hi upi 1');
			} else if (split?.amount > upi?.amount && upi?.amount > 0) {
				payment.push({
					payment_type: 'UPI',
					reference_number: upi.reference_number.toString(),
					amount: upi.amount,
					bank_statement_id: upi.bank_statement_id,
				});
				split.amount -= upi.amount;
				upi.amount = 0;
				console.log('hi upi 22');
			}
		}
	});

	collected?.chequeData?.forEach((cheque) => {
		if (cheque?.reference_number && cheque?.due_date && cheque?.amount && cheque?.bank_id) {
			if (split?.amount <= cheque?.amount && split?.amount > 0) {
				payment.push({
					payment_type: 'Cheque',
					reference_number: cheque.reference_number.toString(),
					due_date: moment(cheque.due_date).format('YYYY-MM-DD'),
					amount: split.amount,
					bank_id: Number(cheque.bank_id),
				});
				cheque.amount -= split.amount;
				split.amount = 0;
			} else if (split?.amount > cheque?.amount && cheque?.amount > 0) {
				payment.push({
					payment_type: 'Cheque',
					reference_number: cheque.reference_number.toString(),
					due_date: moment(cheque.due_date).format('YYYY-MM-DD'),
					amount: cheque.amount,
					bank_id: Number(cheque.bank_id),
				});
				split.amount -= cheque.amount;
				cheque.amount = 0;
			}
		}
	});

	collected?.neftData?.forEach((neft) => {
		if (neft?.reference_number && neft?.amount) {
			if (split?.amount <= neft?.amount && split?.amount > 0) {
				payment.push({
					payment_type: 'NEFT',
					reference_number: neft.reference_number.toString(),
					amount: split.amount,
				});
				neft.amount -= split.amount;
				split.amount = 0;
			} else if (split?.amount > neft?.amount && neft?.amount > 0) {
				payment.push({
					payment_type: 'NEFT',
					reference_number: neft.reference_number.toString(),
					amount: neft.amount,
				});
				split.amount -= neft.amount;
				neft.amount = 0;
			}
		}
	});

	console.log('payment push --------', payment);

	return payment;
}
